'use client';

var translations = {
    'How you match this job': 'Mức độ phù hợp công việc',
    'View detail': 'Xem chi tiết',
    'You match this job': 'Bạn phù hợp với công việc này',
    'Job matching analysis': 'Phân tích độ phù hợp công việc',
    'Matching': 'Phù hợp',
    'Highly matching': 'Rất phù hợp',
    'Skills': 'Kỹ năng',
    'You possess {numOfSkill} skills required for this job. Add more skills to make your profile more impressive.': 'Bạn thoả {numOfSkill} kỹ năng được yêu cầu. Hãy thêm các kỹ năng khác để hồ sơ của bạn nổi bật hơn.',
    'Congratulations! You possess {numOfSkill} skills required for this job.': 'Chúc mừng! Bạn thỏa {numOfSkill} kỹ năng được yêu cầu.',
    'Skills on your profile': 'Những kỹ năng có trong hồ sơ của bạn',
    'Skills missing on your profile': 'Những kỹ năng cần bổ sung trong hồ sơ của bạn',
    'Work experience': 'Kinh nghiệm làm việc',
    'Your level vs. required job level.': 'Cấp bậc của bạn so với yêu cầu công việc.',
    'Career path': 'Định hướng nghề nghiệp',
    'This job matches {numOfCriteria} criteria in your career path. Update your profile frequently to let us know your latest career path.': 'Công việc này thỏa {numOfCriteria} tiêu chí định hướng nghề nghiệp của bạn. Hãy cập nhật hồ sơ thường xuyên để chúng tôi biết được định hướng mới nhất của bạn nhé.',
    'My VietnamWorks profile:': 'Hồ sơ VietnamWorks của tôi:',
    'A complete and updated profile is more attractive to employers.': 'Hồ sơ hoàn chỉnh và được cập nhật mới sẽ thu hút nhà tuyển dụng hơn.',
    'Profile strength': 'Hoàn chỉnh hồ sơ',
    'Last update:': 'Cập nhật lần cuối:',
    'Update My profile': 'Cập nhật Hồ sơ của tôi',
    'Apply now': 'Ứng tuyển ngay',
    'Job level:': 'Cấp bậc:',
    'Working location': 'Địa điểm làm việc',
    'Salary': 'Mức lương',
    '/my-profile': '/ho-so',
    'Job function': 'Ngành nghề',
    'Industry': 'Lĩnh vực',
    'Job title': 'Chức danh',
    'Added successfully': 'Thêm thành công',
    'Removed successfully': 'Xóa thành công',
    'Error: unable to add skills': 'Lỗi: không thể thêm kỹ năng',
    'You had the maximum of skills.': 'Bạn đã đạt số lượng kỹ năng tối đa.',
    'The assessment is for reference only, based on your VietnamWorks profile and the requirements of this job.': 'Đánh giá mang tính tham khảo, dựa trên Hồ sơ VietnamWorks của bạn và yêu cầu công việc này.',
    'Your Skill has been added successfully': 'Kỹ Năng của bạn đã được thêm thành công',
    'Your Skill has been removed successfully': 'Kỹ Năng của bạn đã được xóa thành công',
};

export { translations as default };
//# sourceMappingURL=translations.js.map
